import React, { useState } from 'react';
import './Routes.scss';
import { Avatar, Badge, Divider, Grid, List, ListItem, ListItemSecondaryAction, ListItemText, Accordion, AccordionSummary, AccordionDetails } from '@material-ui/core';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import Constants from "../Common/Constants"
import { styled } from '@mui/material/styles';
import { IVerticalStepper } from '../Models/IVerticalStepper';
import { NotificationPopup } from '../Subcomponent/Shared/NotificationPopup'
import { INotificationPopupSettings, IButton } from '../Models/INotificationPopupSettings';
import { CustomerResponse } from '../Subcomponent/Shared/CustomerResponse'
import { useDispatch, useSelector } from 'react-redux';
import './Dashboard.scss'
import { CloseIcon, DirectionsCar, ExpandMoreIcon, DateRangeIcon, AssignmentLateIcon, MarkEmailReadIcon, TimelapseOutlinedIcon } from "../Subcomponent/Shared/SharedIcons";

import { makeStyles } from "@material-ui/core/styles";
import { useNavigate } from 'react-router-dom';
import CustomerWaiting from '../Subcomponent/Dashboard/CustomerWaiting';
import Utils from '../Common/Utils';
import allActions from '../Store/Actions/AllActions';
import StoreManager from '../Managers/Store.manager';
import OrderManager from '../Managers/Orders.Manager';
import OrderLineShimmer from '../Subcomponent/PickOrder/OrderLineShimmer';

import OrderCountShimmer from '../Subcomponent/Dashboard/OrderCountShimmer';
import StatusBtn from '../Subcomponent/Shared/StatusBtn';
import NoDataFound from '../Subcomponent/Shared/NoDataFound';
import BulletShimmer from '../Subcomponent/Shared/BulletShimmer';
import IdentityManager from '../Managers/Identity.manager';
import ShipmentStatusConstant from "../Common/ShipmentStatusConstants";
import { OrderDetailNotificationPopup } from '../Subcomponent/Shared/OrderDetailNotificationPopup';
import { DashboardGrid } from './DashboardGrid';
import DashboardPendingGrid from './DashboardPendingGrid';
import DashboardPendingGridMobile from './DashboardPendingGridMobile';

const Dashboard = (props: any) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    let orderCount = useSelector((state: any) => state.DashboardReducerState.orderCount);
    let expedited = useSelector((state: any) => state.DashboardReducerState.expedited);
    let resourced = useSelector((state: any) => state.DashboardReducerState.resourced);
    let pendingCustomers = useSelector((state: any) => state.DashboardReducerState.pendingCustomers);
    let pendingCustomerDecisions = useSelector((state: any) => state.DashboardReducerState.pendingCustomerDecisions);
    const stores = useSelector((state: any) => state.ActionLoaderReducersState.stores);
    const districtsList = useSelector((state: any) => state.ActionLoaderReducersState.districts);
    const regionsList = useSelector((state: any) => state.ActionLoaderReducersState.regions);
    let [isOrderCountLoaded, setOrderCountLoaded] = useState(false);
    let [isExpeditedloaded, setExpediteLoaded] = useState(false);
    let [isResourcedloaded, setResourcedLoaded] = useState(false);
    let [isPendingCustomersloaded, setPendingCustomersLoaded] = useState(false);
    let [isPendingCustomerDecisionsloaded, setPendingCustomerDecisionsLoaded] = useState(false);
    const [status, setStatus] = useState(0);
    const [contactCustomerData, setContactCustomerData] = useState({} as any)
    const [customerResponse, setCustomerResponse] = useState(false);
    const [openInfo, setOpenInfo] = useState(false);
    let [viewAllExpedited, setViewAllExpedited] = useState(false);
    let [viewAllResourced, setViewAllResourced] = useState(false);
    let [viewAllPendingCustomers, setViewAllPendingCustomers] = useState(false);
    let [viewAllPendingCustomerDecisions, setViewAllPendingCustomerDecisions] = useState(false);




    const closeCustomerResponse = () => {
        setCustomerResponse(false)
    }
    const openCustomerResponse = () => {
        setCustomerResponse(true)
    }

    const openInfoPopup = () => {
        setOpenInfo(true);
        updateStatusState();
    }

    const closeInfoPopup = () => {
        setOpenInfo(false)
    }

    const updateStatusState = () => {
        setStatus(status + 1);
    }

    const clickCustomerResponseIcon = (e: any, data: any) => {
        console.log(data)
        e.stopPropagation()
        setContactCustomerData(data)
        openCustomerResponse()
    }
    let customerResponseButtons: IButton[] = [
        {
            text: "Close",
            icon: <CloseIcon />,
            action: closeCustomerResponse,
            color: Constants.Colors.blue,
        }]
    let showCustomerResponse: INotificationPopupSettings = {
        open: customerResponse,
        type: Constants.NotificationPopupType.Info,
        title: "Customer Response",
        msg: "",
        handleClose: closeCustomerResponse,
        isCustomJSX: true,
        customJSX: <CustomerResponse {...contactCustomerData}></CustomerResponse>,
        actions: customerResponseButtons,
        fullWidth: true,
        maxWidth: "lg"
    }

    let Info = {
        open: openInfo,
        msg: "The Order Status has been changed. Your screen will automatically refresh now.",
        handleClose: closeInfoPopup,
        zIndex: 10000000
    };

    const showActionLoader = () => {
        dispatch(allActions.actionLoaderActions.showLoader());
    }
    const hideActionLoader = () => {
        dispatch(allActions.actionLoaderActions.hideLoader());
    }
    const useStyles: any = makeStyles((theme) => ({
        root: {
            backgroundColor: theme.palette.primary.main
        }
    }));
    const classes = useStyles();
    const [expandResource, setExpandResource] = React.useState(Utils.isDesktop);
    const handleResource = () => {
        setExpandResource(!expandResource);
    };
    const [expandExpedited, setExpandExpedited] = React.useState(Utils.isDesktop);
    const [expandedDecisions, setExpandedDecisions] = React.useState(Utils.isDesktop);
    const [expandedPickup, setExpandedPickup] = React.useState(Utils.isDesktop);
    const handleExpedited = () => {
        setExpandExpedited(!expandExpedited);
    };
    const handleDecisions = () => {
        setExpandedDecisions(!expandedDecisions);
    };
    const handlePickup = () => {
        setExpandedPickup(!expandedPickup);
    };

    const navigateToOrder = async (shipmentKey: any, orderNo: any, type: any, storeId: any) => {
        showActionLoader();
        let detailStatus = true;

        await Utils.checkOrderDetailStatus({
            shipmentKey: shipmentKey,
            status: type,
        }).then((res: any) => {
            if (res?.success) {
                detailStatus = res.data;
            }
        }).catch((err: any) => {
            console.log("Order Detail Status Error", err);
        })

        switch (type) {
            case ShipmentStatusConstant.ReadyForPick:
                if (detailStatus) {
                    hideActionLoader();
                    navigate("/PickOrder?orderno=" + orderNo + "&shipmentkey=" + shipmentKey + "&store=" + storeId + "");
                }
                else {
                    hideActionLoader();
                    openInfoPopup();
                }
                break;
            case ShipmentStatusConstant.ReadyForCustomerPickup:
                if (detailStatus) {
                    hideActionLoader();
                    navigate("/CustomerPickup?orderno=" + orderNo + "&shipmentkey=" + shipmentKey + "&store=" + storeId + "");
                }
                else {
                    hideActionLoader();
                    openInfoPopup();
                }
                break;
            default:
                break;
        }
    }
    const quickActionsMobile = () => {
        return (
            <DashboardPendingGridMobile orderCount={orderCount} isOrderCountLoaded={isOrderCountLoaded} navigateToDrawer={props.navigateToDrawer}></DashboardPendingGridMobile>
        );
    }
    const quickActionsWeb = () => {
        return (
            <DashboardPendingGrid orderCount={orderCount} isOrderCountLoaded={isOrderCountLoaded} navigateToDrawer={props.navigateToDrawer}></DashboardPendingGrid>
        );
    }

    const loadOrderCountData = async () => {
        let storeId = IdentityManager.getMultipleStoresId(props.store);
        let aggPayload = {
            "store": storeId
        };
        if (storeId) {
            OrderManager.getOrdersAggregatesWrapper(aggPayload).then((orderCount: any) => {
                setOrderCountLoaded(true);
                if (orderCount) {
                    dispatch(allActions.dashboardActions.loadDashboardOrdersCount(orderCount));
                }
            });

        }
        else {
            setOrderCountLoaded(true);
        }


    }

    const renderResourceCounr = (shipment: any) => {


        const result = shipment?.ShipmentLines?.ShipmentLine.reduce((accumulator: any, obj: any) => {
            return accumulator + Number(obj.ExtnRescheduleReqCount ? obj.ExtnRescheduleReqCount : "0");
        }, 0);
        return <React.Fragment>
            <span className='resourceCount' title='Order Resource Count'>
                {result}
            </span>
        </React.Fragment>

    }

    const loadDasboardOrders = async () => {
        let storeId = IdentityManager.getMultipleStoresId(props.store);
        let pSize = StoreManager.config.pSize
        let payload = {
            "store": storeId,
            "pSize": Number(pSize)
        };
        if (storeId && storeId.length == 1) {
            OrderManager.getReSourcedOrders(payload).then((orders: any) => {
                if (orders) {
                    dispatch(allActions.dashboardActions.loadDashboardResourceOrders(orders));
                    setResourcedLoaded(true);
                }
            });

            OrderManager.getExpeditedIrders(payload).then((orders: any) => {
                if (orders) {
                    dispatch(allActions.dashboardActions.loadDashboardExpeditedOrders(orders));
                    setExpediteLoaded(true);
                }
            });

            OrderManager.getPendingCustomerPickupOrders(payload).then((orders: any) => {
                if (orders) {
                    dispatch(allActions.dashboardActions.loadDashboardPendingCustomerOrders(orders));
                    setPendingCustomersLoaded(true);
                }
            });

            OrderManager.getPendingCustomerDecisionsOrders(payload).then((orders: any) => {

                if (orders) {
                    dispatch(allActions.dashboardActions.loadDashboardPendingCustomerDecisionsOrders(orders));
                    setPendingCustomerDecisionsLoaded(true);
                }
            });

        }
        else {
            setResourcedLoaded(true);
            setExpediteLoaded(true);
            setPendingCustomersLoaded(true);
            setPendingCustomerDecisionsLoaded(true);
        }


    }

    const initailizeCall = async () => {
        loadOrderCountData();
        loadDasboardOrders();
    }
    React.useEffect(() => {

        setOrderCountLoaded(false);
        setExpediteLoaded(false);
        setResourcedLoaded(false);
        setPendingCustomerDecisionsLoaded(false);
        setPendingCustomersLoaded(false);
        // if (props.store.length > 1) {
        //     loadDasboardOrders();
        // }
        async function sendRequest() {
            initailizeCall();
        }

        // This will help to keep shimmers loading untill we fetch the stores and set the user store
        if ((stores && stores.length > 0)) {
            sendRequest();

        }
        if (props.store.length == 1) {
            const intervalId = setInterval(() => {
                sendRequest()
            }, 1000 * 30) // in milliseconds
            return () => {
                clearInterval(intervalId);
            }
        }
    }, [props.store, stores, status]);
    React.useEffect(() => {
        if (stores && stores.length > 0 && districtsList && districtsList.length > 0) {
            props.selectProfileStores();
        }
    }, [stores, districtsList])

    React.useEffect(() => {
        if (regionsList.length > 0 && IdentityManager.isEnterprise) {
            props.selectAllRegions();
        }
    }, [regionsList])
    return (
        <div className={Utils.isMobile ? "innerContianerMobile" : "innerContianer"}>
            <NotificationPopup {...showCustomerResponse}>
            </NotificationPopup>
            <OrderDetailNotificationPopup {...Info}>
            </OrderDetailNotificationPopup>
            {Utils.isMobile ? quickActionsMobile() : quickActionsWeb()}
            <Grid container spacing={2} style={{ paddingLeft: 3, paddingRight: 3, marginBottom: 10 }}>
                <Grid item xs={12} sm={6} style={{ display: "none" }}>
                    <Card className='dCard' >
                        <CardContent className='dCardContent' style={{ minHeight: 490 }}>
                            <div className='dCardHeader'>
                                <div className='icon'>
                                    <DirectionsCar></DirectionsCar>
                                </div>
                                <div className='header' style={{ marginTop: "4px" }}>
                                    <Typography gutterBottom>
                                        Customer Waiting
                                    </Typography>
                                </div>
                            </div>
                            <Divider />
                            <CustomerWaiting></CustomerWaiting>
                        </CardContent>
                    </Card>
                </Grid>
                <Grid item xs={12} sm={12}>
                    {props.store.length <= 1 &&
                        <>
                            <Grid container alignItems="center">
                                <div className="cardsHeader">
                                    Needs Attention
                                </div>
                            </Grid>
                            <Grid container spacing={1}>
                                <Grid item lg={3} md={6} xs={12} sm={6} style={{ paddingLeft: 3, paddingRight: 3 }}>
                                    <Accordion expanded={expandedDecisions} onChange={() => handleDecisions()} style={{ borderRadius: 16, height: expandedDecisions ? 500 : 80, boxShadow: "0px 1px 1px 1px rgb(0 0 0 / 20%), 0px 1px 1px 1px rgb(0 0 0 / 14%), 0px 1px 1px 2px rgb(0 0 0 / 12%)" }}>
                                        <AccordionSummary
                                            expandIcon={<ExpandMoreIcon />}
                                            aria-controls="panel1a-content"
                                            id="panel1a-header"
                                            style={{ color: Constants.Colors.darkGrey, height: 80 }}
                                        >
                                            {/* <CallReceived></CallReceived> */}
                                            <Typography className='accordianHeading'><b>Pending Cust. Decisions</b></Typography>
                                            <Avatar
                                                className="accordianAvatar"
                                            >
                                                {pendingCustomerDecisions ? pendingCustomerDecisions.length : "0"}
                                            </Avatar>
                                        </AccordionSummary>
                                        <Divider />
                                        <AccordionDetails style={{ display: "block", padding: 0, minHeight: "410px", overflowY: "scroll" }}>
                                            {isPendingCustomerDecisionsloaded ? <React.Fragment>
                                                {pendingCustomerDecisions && pendingCustomerDecisions.length > 0 ? <React.Fragment>
                                                    <List style={{ height: "250px" }}>
                                                        {pendingCustomerDecisions.slice(0, viewAllPendingCustomerDecisions ? pendingCustomerDecisions.length : 4).map((item: any, index: any) => {
                                                            return (
                                                                <ListItem style={{
                                                                    backgroundColor: index % 2 === 0 ? Constants.Colors.greybackground : Constants.Colors.white // Alternating row colors
                                                                }}
                                                                    onClick={() => { navigateToOrder(item._source.shipmentkey, item._source.orderno, ShipmentStatusConstant.ReadyForPick, item._source.store) }}
                                                                    key={index}>
                                                                    <ListItemText disableTypography
                                                                        primary={<Typography className="listHeading"><b>{item._source.orderno}</b></Typography>}
                                                                        secondary={
                                                                            <div style={{ display: "" }}>
                                                                                <Typography style={{ display: "", fontSize: "13px", fontWeight: "400", color: Constants.Colors.dimGrey }} >
                                                                                    {
                                                                                        item._source.responded == "true" ?
                                                                                            "Customer Responded"
                                                                                            :
                                                                                            "Waiting Customer Response"
                                                                                    }
                                                                                </Typography>
                                                                                <Typography style={{ display: "", fontSize: "13px", fontWeight: "400", color: Constants.Colors.dimGrey }} >
                                                                                    {
                                                                                        item._source.responded == "true" ?
                                                                                            <React.Fragment>
                                                                                                {Utils.convertElasticDateToPst(item._source.customerresponsedate)}
                                                                                            </React.Fragment>
                                                                                            :
                                                                                            <React.Fragment>
                                                                                                {Utils.convertElasticDateToPst(item._source.transactionDate)}
                                                                                            </React.Fragment>
                                                                                    }
                                                                                </Typography>
                                                                            </div>
                                                                        } />
                                                                    <ListItemSecondaryAction>
                                                                        {
                                                                            item._source.responded == "true" ?
                                                                                <MarkEmailReadIcon style={{ cursor: "pointer", color: Constants.Colors.green }} titleAccess="Customer Responded" onClick={(e: any) => clickCustomerResponseIcon(e, item._source)} />
                                                                                :
                                                                                <TimelapseOutlinedIcon style={{ cursor: "pointer", color: Constants.Colors.red }} titleAccess="Waiting for Customer Response" onClick={(e: any) => clickCustomerResponseIcon(e, item._source)} />
                                                                        }

                                                                    </ListItemSecondaryAction>
                                                                </ListItem>
                                                            );
                                                        })}
                                                        {
                                                            (pendingCustomerDecisions.length > 4 && viewAllPendingCustomerDecisions == false) ?
                                                                <ListItem style={{ justifyContent: "center", paddingTop: "0px", paddingBottom: "0px" }}>
                                                                    <p style={{ color: Constants.Colors.red, cursor: "pointer" }} onClick={() => setViewAllPendingCustomerDecisions(true)}><u>View All</u></p>
                                                                </ListItem>
                                                                :
                                                                <></>
                                                        }

                                                    </List>
                                                </React.Fragment> : <NoDataFound msg='No Pending Customer Decisions'></NoDataFound>}
                                            </React.Fragment> : <BulletShimmer></BulletShimmer>}
                                        </AccordionDetails>
                                    </Accordion>
                                </Grid>
                                <Grid item lg={3} md={6} xs={12} sm={6} style={{ paddingLeft: 3, paddingRight: 3 }}>
                                    <Accordion expanded={expandedPickup} onChange={() => handlePickup()} style={{ borderRadius: 16, height: expandedPickup ? 500 : 80, boxShadow: "0px 1px 1px 1px rgb(0 0 0 / 20%), 0px 1px 1px 1px rgb(0 0 0 / 14%), 0px 1px 1px 2px rgb(0 0 0 / 12%)" }}>
                                        <AccordionSummary
                                            expandIcon={<ExpandMoreIcon />}
                                            aria-controls="panel1a-content"
                                            id="panel1a-header"
                                            style={{ color: Constants.Colors.darkGrey, height: 80 }}
                                        >
                                            {/* <CallReceived></CallReceived> */}
                                            <Typography className='accordianHeading'><b>Overdue Cust. Pickup</b></Typography>
                                            <Avatar
                                                className="accordianAvatar"
                                            >
                                                {pendingCustomers ? pendingCustomers.length : ""}
                                            </Avatar>
                                        </AccordionSummary>
                                        <Divider />
                                        <AccordionDetails style={{ display: "block", padding: 0, minHeight: "410px", overflowY: "scroll", overflowX: "hidden" }}>
                                            {isPendingCustomersloaded ? <React.Fragment>
                                                {pendingCustomers && pendingCustomers.length > 0 ? <React.Fragment>
                                                    <List style={{ height: "250px" }}>
                                                        {pendingCustomers.slice(0, viewAllPendingCustomers ? pendingCustomers.length : 5).map((item: any, index: any) => {
                                                            return (
                                                                <ListItem
                                                                    style={{
                                                                        backgroundColor: index % 2 === 0 ? Constants.Colors.greybackground : Constants.Colors.white // Alternating row colors
                                                                    }}
                                                                    onClick={() => { navigateToOrder(item._source.Shipment.ShipmentKey, item._source.Shipment.OrderNo, ShipmentStatusConstant.ReadyForCustomerPickup, item._source.Shipment.ExtnPickupStoreID ? item._source.Shipment.ExtnPickupStoreID : 0) }}
                                                                    key={index}>
                                                                    <ListItemText disableTypography
                                                                        primary={<Typography className="listHeading"><b>{item._source.Shipment.OrderNo}</b></Typography>}
                                                                        secondary={
                                                                            <div style={{ display: "" }}>
                                                                                <Typography style={{ display: "", fontSize: "13px", fontWeight: 400, color: Constants.Colors.dimGrey }} >{"Waiting on Customer Pickup"}
                                                                                </Typography>
                                                                            </div>
                                                                        } />
                                                                    <ListItemSecondaryAction>
                                                                        {/* <Badge badgeContent={Utils.getDateDiffFromToday(item._source?.Shipment?.StatusDate)} style={{ color: Constants.Colors.red, fontSize: "0.95rem" }} showZero>
                                                                            <DateRangeIcon />
                                                                        </Badge> */}
                                                                        <div style={{ display: "flex", alignItems: "center", color: Constants.Colors.red }}>
                                                                            <DateRangeIcon />
                                                                            <div style={{ marginRight: "8px" }}></div>
                                                                            <Badge
                                                                                badgeContent={Utils.getDateDiffFromToday(item._source?.Shipment?.StatusDate)}
                                                                                style={{ fontSize: "0.95rem", marginLeft: "4px" }} // Adjust margin-left for spacing
                                                                                showZero
                                                                            />
                                                                        </div>

                                                                    </ListItemSecondaryAction>
                                                                </ListItem>
                                                            )
                                                        })}
                                                        {
                                                            (pendingCustomers.length > 5 && viewAllPendingCustomers == false) ?
                                                                <ListItem style={{ justifyContent: "center" }}>
                                                                    <p style={{ color: Constants.Colors.red, cursor: "pointer" }} onClick={() => setViewAllPendingCustomers(true)}><u>View All</u></p>
                                                                </ListItem>
                                                                :
                                                                <></>
                                                        }
                                                    </List>

                                                </React.Fragment> : <NoDataFound msg='No Overdue Customer Pickup'></NoDataFound>}
                                            </React.Fragment> : <BulletShimmer></BulletShimmer>}


                                        </AccordionDetails>
                                    </Accordion>
                                </Grid>
                                <Grid item lg={3} md={6} xs={12} sm={6} style={{ paddingLeft: 3, paddingRight: 3 }}>
                                    <Accordion expanded={expandResource} className={resourced && resourced.length > 0 && "scroll-class"} onChange={() => handleResource()} style={{ borderRadius: 16, height: expandResource ? 500 : 80, boxShadow: "0px 1px 1px 1px rgb(0 0 0 / 20%), 0px 1px 1px 1px rgb(0 0 0 / 14%), 0px 1px 1px 2px rgb(0 0 0 / 12%)" }}>
                                        <AccordionSummary
                                            expandIcon={<ExpandMoreIcon />}
                                            aria-controls="panel1a-content"
                                            id="panel1a-header"
                                            style={{ color: Constants.Colors.darkGrey, height: 80 }}
                                        >
                                            {/* <CallReceived></CallReceived> */}
                                            <Typography className='accordianHeading'><b>Resourced Orders</b></Typography>
                                            <Avatar
                                                className="accordianAvatar"
                                            >
                                                {resourced ? resourced.length : ""}
                                            </Avatar>
                                        </AccordionSummary>

                                        <Divider style={{ minWidth: "250px" }} />
                                        <AccordionDetails style={{ display: "block", padding: 0, minHeight: "410px", minWidth: resourced && resourced.length > 0 && "250px", overflow: "scroll" }}>

                                            {isResourcedloaded ? <React.Fragment>
                                                {resourced && resourced.length > 0 ? <React.Fragment>
                                                    <List style={{ height: "250px" }}>
                                                        {resourced.slice(0, viewAllResourced ? resourced.length : 5).map((item: any, index: any) => (
                                                            <ListItem
                                                                style={{
                                                                    maxHeight: 72.02, backgroundColor: index % 2 === 0 ? Constants.Colors.greybackground : Constants.Colors.white // Alternating row colors
                                                                }}
                                                                key={index}>
                                                                <ListItemText disableTypography
                                                                    primary={
                                                                        <React.Fragment>
                                                                            <Typography className="listHeading"><b>{item._source.Shipment.OrderNo}</b>
                                                                                {renderResourceCounr(item._source.Shipment)}
                                                                            </Typography>
                                                                        </React.Fragment>

                                                                    }
                                                                    secondary={
                                                                        <div style={{ display: "" }}>
                                                                            {/* <Typography style={{ display: "", fontSize: "12px", color: "rgba(0, 0, 0, 0.54)" }} >{"Created On:"} */}
                                                                            {/* </Typography> */}
                                                                            <Typography style={{ display: "", fontSize: "13px", fontWeight: "400", color: Constants.Colors.dimGrey }} >{Utils.convertElasticDateToPst(item._source.Shipment?.OrderDate)}
                                                                            </Typography>
                                                                        </div>
                                                                    } />
                                                                <ListItemSecondaryAction>
                                                                    <StatusBtn item={item} openInfo={openInfoPopup}></StatusBtn>
                                                                </ListItemSecondaryAction>
                                                            </ListItem>
                                                        ))}
                                                        {
                                                            (resourced.length > 5 && viewAllResourced == false) ?
                                                                <ListItem style={{ justifyContent: "center", paddingTop: "4px", paddingBottom: "4px" }}>
                                                                    <p style={{ color: Constants.Colors.red, cursor: "pointer" }} onClick={() => setViewAllResourced(true)}><u>View All</u></p>
                                                                </ListItem>
                                                                :
                                                                <></>
                                                        }
                                                    </List>
                                                </React.Fragment> : <NoDataFound msg='No Resourced Orders'></NoDataFound>}
                                            </React.Fragment> : <BulletShimmer></BulletShimmer>}


                                        </AccordionDetails>
                                    </Accordion>
                                </Grid>
                                <Grid item lg={3} md={6} xs={12} sm={6} style={{ paddingLeft: 3, paddingRight: 3 }}>
                                    <Accordion expanded={expandExpedited} className={resourced && resourced.length > 0 && "scroll-class"} onChange={() => handleExpedited()} style={{ borderRadius: 16, height: expandExpedited ? 500 : 80, boxShadow: "0px 1px 1px 1px rgb(0 0 0 / 20%), 0px 1px 1px 1px rgb(0 0 0 / 14%), 0px 1px 1px 2px rgb(0 0 0 / 12%)" }}>
                                        <AccordionSummary
                                            expandIcon={<ExpandMoreIcon />}
                                            aria-controls="panel1a-content"
                                            id="panel1a-header"
                                            style={{ color: Constants.Colors.darkGrey, height: 80 }}
                                        >
                                            {/* <CallReceived></CallReceived> */}
                                            <Typography className='accordianHeading'><b>Expedited Shipping</b></Typography>
                                            <Avatar
                                                className="accordianAvatar"
                                            >
                                                {expedited ? expedited.length : ""}
                                            </Avatar>
                                        </AccordionSummary>
                                        <Divider style={{ minWidth: "250px" }} />
                                        <AccordionDetails style={{ display: "block", padding: 0, minHeight: "410px", minWidth: resourced && resourced.length > 0 && "250px", overflowY: "scroll" }}>
                                            {isExpeditedloaded ? <React.Fragment>
                                                {expedited && expedited.length > 0 ? <React.Fragment>
                                                    <List style={{ height: "250px" }}>
                                                        {expedited.slice(0, viewAllExpedited ? expedited.length : 5).map((item: any, index: any) => (
                                                            <ListItem style={{
                                                                backgroundColor: index % 2 === 0 ? Constants.Colors.greybackground : Constants.Colors.white // Alternating row colors
                                                            }}
                                                                key={index}>
                                                                <ListItemText disableTypography primary={<Typography className="listHeading"><b>{item._source.Shipment.OrderNo}</b></Typography>} secondary={
                                                                    <div style={{ display: "" }}>
                                                                        <Typography style={{ display: "", fontSize: "13px", fontWeight: 400, color: Constants.Colors.dimGrey }} >{"Ship By End of Day"}
                                                                        </Typography>
                                                                    </div>
                                                                } />
                                                                <ListItemSecondaryAction>
                                                                    <StatusBtn item={item} openInfo={openInfoPopup}></StatusBtn>
                                                                </ListItemSecondaryAction>
                                                            </ListItem>
                                                        ))}
                                                        {
                                                            (expedited.length > 5 && viewAllExpedited == false) ?
                                                                <ListItem style={{ justifyContent: "center" }}>
                                                                    <p style={{ color: Constants.Colors.red, cursor: "pointer" }} onClick={() => setViewAllExpedited(true)}><u>View All</u></p>
                                                                </ListItem>
                                                                :
                                                                <></>
                                                        }
                                                    </List>
                                                </React.Fragment> : <NoDataFound msg='No Expedited Shipping'></NoDataFound>}
                                            </React.Fragment> : <BulletShimmer></BulletShimmer>}



                                        </AccordionDetails>
                                    </Accordion>
                                </Grid>


                            </Grid>

                        </>}
                </Grid>
            </Grid>
            {props.store.length > 1 && <>
                <Grid container alignItems="center">
                    <div className="cardsHeader" style={{marginLeft:Utils.isMobile? "5px":"0px"}}>
                        Fulfillment Backlog
                    </div>
                </Grid>
                <Grid item sm={12}>
                    <DashboardGrid store={props.store} district={props.district} changeDistrict={props.changeDistrict} changeRegion={props.changeRegion} changeStore={props.changeStore} />
                </Grid>
            </>}
            <Grid container spacing={2} style={{ display: "none" }}>
                <Grid item xs={12} sm={6}>
                    <Card className='dCard'>
                        <CardContent>
                            <div className='dCardHeader'>
                                <div className='icon'>
                                    <DirectionsCar></DirectionsCar>
                                </div>
                                <div className='header' style={{ marginTop: "4px" }}>
                                    <Typography gutterBottom>
                                        Store Orders Status (Today vs Yesterday)
                                    </Typography>
                                </div>
                            </div>
                            <Divider />

                        </CardContent>
                    </Card>
                </Grid>
                <Grid item xs={12} sm={6}>
                    <Card className='dCard'>
                        <CardContent style={{ paddingBottom: "5px" }}>
                            <div className='dCardHeader'>
                                <div className='icon'>
                                    <DirectionsCar></DirectionsCar>
                                </div>
                                <div className='header' style={{ marginTop: "4px" }}>
                                    <Typography gutterBottom>
                                        Orders Booked/Cancelled Status (Last 7 days)
                                    </Typography>
                                </div>
                            </div>
                            <Divider />

                        </CardContent>
                    </Card>
                </Grid>
            </Grid>
        </div >
    );

}


export default Dashboard;